define((require) => {
    "use strict";

    const Collection = require("backbone").Collection;
    const Scene      = require("shared/ui/experience/Scene");

    /**
     * A collection for scenes.
     *
     * @see Scene
     * @class SceneCollection
     */
    return Collection.extend({
        model: Scene
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/SceneCollection.js